import React from 'react';
import { ClientDashboardCard } from '../../components/ClientDashboard';
import { CommonHeader } from '../../components/commons';
import { RootState } from '../../redux/rootReducers';
import { connect } from 'react-redux';

type AppProps = {
  history?: any;
  sideMenus?:any[];
}

const index = ({
  history,
  sideMenus
}: AppProps) => {

  const handleRedirection = (moduleName: string | undefined) => {
    switch (moduleName) {
      case 'redirectToNonRecurringJobs':
        return history.push(`/jobs/jobs-list`);
      case 'redirectToJobsType':
        return history.push('/jobs/jobs-type');
      case 'redirectToRecurringJobs':
        return history.push('/jobs/recurring-jobs');
      case 'redirectToRecurringJobsReport':
        return history.push('/jobs/recurring-jobs-report');
      default:
        return null;
    }
  };

  const renderModules = () => {
    window.scroll({
      top:0,
      left:0
    })
  
    let index: any = sideMenus && sideMenus?.length > 0 && sideMenus?.filter(menu => menu?.menu_name === 'Jobs');
  
  
    let finalList = index[0]?.sub_menu?.map((list:any) => {
      return (
        <div className={`col-md-4 mb-4 ${ list.extraClasses }`}>
          <ClientDashboardCard
            isNew={list.is_new}
            key={list.menu_name}
            name={list.menu_name}
            description={list.description}
            icon={<i className={list.icon}></i>}
            action={() => handleRedirection(list.action)}
            comingSoon={list.comingSoon}
          />
        </div>
      )
    });

    return finalList;
  };

  return (
    <>
      <CommonHeader
        title='Job Tracker'
      />
      <div className="row mt-3">
        {renderModules()}
      </div>
    </>
  )
};

const mapStateToProps = (state: RootState) => ({
  sideMenus:state.auth.sideMenus
})
export default connect(mapStateToProps) (index)